import { useState } from "react";

export function usePopup() {
  const [popup, setPopup] = useState({
    recalculate: false,
    export: false,
    upload: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  return { popup, openPopup, closePopup };
}
